import { useState, useRef, useEffect } from "react";
import { debugLog } from "../services/debugLog";

export default function useSpeechToText({ lang, onResult }) {
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);

  const isSupported =
    typeof window !== "undefined" &&
    ("webkitSpeechRecognition" in window || "SpeechRecognition" in window);

  useEffect(() => {
    if (typeof onResult !== "function") {
      console.warn("🟡 Speech recognition deshabilitado: onResult no es función");
    }
  }, [onResult]);

  useEffect(() => {
    if (!isSupported) return;

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();

    recognition.lang = lang || "es-ES"; // Default to Spanish
    recognition.interimResults = false; // Don't show interim results
    recognition.maxAlternatives = 1;
    recognition.continuous = true; // Keep listening until stopped

    recognition.onstart = () => {
      debugLog("🎙️ WebSpeech Reconocimiento iniciado");
    };

    recognition.onspeechend = () => {
      // No cortamos automáticamente, solo informamos
      debugLog("🔕 WebSpeech Silencio detectado.");
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      debugLog("📝 WebSpeech Resultado recibido:", transcript);
      if (onResult) onResult(transcript);
    };

    recognition.onerror = (event) => {
      console.error("WebSpeech Recognition Error:", event.error);
      setIsListening(false);
    };

    recognition.onend = () => {
      debugLog("🛑 WebSpeech Reconocimiento detenido");
      setIsListening(false);
    };

    recognitionRef.current = recognition;
  }, [isSupported, lang, onResult]);

  const startListening = () => {
    if (isSupported && recognitionRef.current) {
      recognitionRef.current.start();
      setIsListening(true);
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
  };

  return {
    isListening,
    startListening,
    stopListening,
  };
}
